<div
  class="yes-no"
  role="group"
  [attr.aria-labelledby]="inputId"
  [ngClass]="{ 'is-invalid': showError }"
>
  <p class="yes-no-label" [id]="inputId">{{ label() }}</p>
  <div class="yes-no-options">
    <button
      type="button"
      class="yes-no-option"
      [ngClass]="{ active: value === true }"
      [attr.aria-pressed]="value === true"
      [disabled]="disabled"
      (click)="select(true)"
    >
      {{ yesText() }}
    </button>
    <button
      type="button"
      class="yes-no-option"
      [ngClass]="{ active: value === false }"
      [attr.aria-pressed]="value === false"
      [disabled]="disabled"
      (click)="select(false)"
    >
      {{ noText() }}
    </button>
  </div>
</div>
@if (showError) {
  <p class="yes-no-error small">{{ getErrorMessage(errorKeys[0]) }}</p>
}
